import React, { useState } from 'react'
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'

import Page from '../../components/Page'
import ScheduleList from './ScheduleList'
import { connect } from 'react-redux'
import {
  getHockeySport,
  getSoccerSport,
} from '@sportninja/common/selectors/types'

const Schedules = ({hockeySport, soccerSport}) => {
  const [scheduleCount, setScheduleCount] = useState('')
  const [favCount, setFavCount] = useState('')

  const pages = [
    {
      to: `${ROUTES.SCHEDULES.ROOT}/my`,
      text: `${t('common:competition', { count: 2 })} ${
        scheduleCount ? `(${scheduleCount})` : ''
      }`,
      component: (
        <ScheduleList
          key='schedules'
          slug='/users/me/schedules'
          setCount={setScheduleCount}
          hockeySport={hockeySport}
          soccerSport={soccerSport}
        />
      ),
    },
    {
      to: `${ROUTES.SCHEDULES.FAVOURITES}`,
      text: `${t('common:favourite', { count: 2 })} ${
        favCount ? `(${favCount})` : ''
      }`,
      component: (
        <ScheduleList
          key='favs'
          slug='/favorites/schedules'
          setCount={setFavCount}
        />
      ),
    },
  ]

  const BASE_ROUTE = `${ROUTES.SCHEDULES.ROOT}`

  return (
    <Page
      baseRoute={BASE_ROUTE}
      pages={pages}
      baseTitle={t('common:competition', { count: 2 })}
      title={t('util:capitalize', {
        text: t('common:competition', { count: 2 }),
      })}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    hockeySportId: getHockeySport(state)?.id,
    soccerSportId: getSoccerSport(state)?.id,
    hockeySport: getHockeySport(state),
    soccerSport: getSoccerSport(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedules)

